import { logger } from '@/core/logger';

export const logError = (error: any, key: string) => {
  const status = error?.status ?? 'Unknown';
  logger.error(`${status} Error ${key}`, { message: error.message });
  console.error(`${status} Error ${key}`, error.message);
};

export const logGraphQLError = (key: string, message: string) => {
  logger.error(`GraphQL error ${key}`, { message });
  console.error(`GraphQL error ${key}`, message);
};
